import React, { useState } from "react";
import ModalCenter from "../../../../../components/common/Modal/ModalCenter";
import InputTextSimple from "../../../../../components/common/InputText/InputTextSimple";
import Button from "../../../../../components/common/buttons/Button";
import TextArea from "../../../../../components/common/TextArea/TextArea";
import { API_ROUTES } from "../../../../../constants/API_ROUTES";
import HttpHelper from "../../../../../helpers/Http/HttpHelper";
import useAuth from "../../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { ROUTES } from "../../../../../constants/Routes";
import Spinner from "../../../../../components/common/Splnner/Spinner";
const CreateCustomerModal = ({ refreshCustomerList }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const { getAuth, clearAuth } = useAuth();

  // firstName
  const [keresztnev, setKeresztnev] = useState("");
  const [keresztnevError, setKeresztnevError] = useState("");
  // lastName
  const [vezeteknev, setVezeteknev] = useState("");
  const [vezeteknevError, setVezeteknevError] = useState("");
  // telephone
  const [telefonszam, setTelefonszam] = useState("");
  const [telefonszamError, setTelefonszamError] = useState("");
  // email
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  // address
  const [cim, setCim] = useState("");
  const [cimError, setCimError] = useState("");

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const reset = () => {
    setKeresztnev("");
    setVezeteknev("");
    setTelefonszam("");
    setEmail("");
    setCim("");

    setKeresztnevError("");
    setVezeteknevError("");
    setTelefonszamError("");
    setEmailError("");
    setCimError("");
  };

  const resetError = () => {
    setKeresztnevError("");
    setVezeteknevError("");
    setTelefonszamError("");
    setEmailError("");
    setCimError("");
  };

  const saveCustomer = () => {
    resetError();
    setIsDisabled(true);
    HttpHelper.PostRequest({
      route: API_ROUTES.CUSTOMER_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        keresztnev: keresztnev,
        vezeteknev: vezeteknev,
        telefonszam: telefonszam,
        email: email,
        cim: cim,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          reset();
          setIsDisabled(false);
          refreshCustomerList();
          closeModal();
          toast.success("Zóna sikeresen létrehozva !", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "keresztnev") {
                setKeresztnevError(errorMessage);
              } else if (key === "vezeteknev") {
                setVezeteknevError(errorMessage);
              } else if (key === "telefonszam") {
                setTelefonszamError(errorMessage);
              } else if (key === "email") {
                setEmailError(errorMessage);
              } else if (key === "cim") {
                setCimError(errorMessage);
              }
            }
          }
          setIsDisabled(false);
        } else if (res.status === 401) {
          clearAuth();
          setIsDisabled(false);
          navigator(ROUTES.AUTH);
        }
      })
      .catch((error) => {
        toast.error("Unknown error !", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };
  // customer Data
  return (
    <>
      <button
        className=" font-lato px-5 py-[0.625rem]  text-center border-2 border-solid bg-white transition-all text-secondary-color active:bg-[#043b48] active:border-[#043b48] hover:text-white ease-in-out duration-200 hover:bg-secondary-color border-secondary-color rounded-[0.675rem] p-[0.675rem]"
        onClick={openModal}
      >
        Új ügyfél hozzáadása
      </button>

      <ModalCenter isOpen={isOpen} closeModal={closeModal} isDisabled={isDisabled} header={`Új ügyfél hozzáadása`}>
        <Spinner spinnerVisible={isDisabled}>
          <div className="flex flex-col gap-[0.625rem] mt-[1.6rem]">
            <label className="text-[1rem] font-lato font-normal leading-normal">
              Vezetéknév<span className="text-red-500">*</span>
            </label>
            <InputTextSimple
              placeholder={`Kovács`}
              variant="light"
              id={"vezeteknev"}
              name={"vezeteknev"}
              value={vezeteknev}
              disabled={isDisabled}
              error={vezeteknevError}
              onChange={(e) => setVezeteknev(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-[0.625rem] mt-[1.6rem]">
            <label className="text-[1rem] font-lato font-normal leading-normal">
              Keresztnév<span className="text-red-500">*</span>
            </label>
            <InputTextSimple
              placeholder={`Béla`}
              variant="light"
              id={"keresztnev"}
              name={"keresztnev"}
              value={keresztnev}
              disabled={isDisabled}
              error={keresztnevError}
              onChange={(e) => setKeresztnev(e.target.value)}
            />
          </div>
          <div className="flex flex-col gap-[0.625rem] mt-[1.6rem]">
            <label className="text-[1rem] font-lato font-normal leading-normal">
              Telefonszáma<span className="text-red-500">*</span>
            </label>
            <InputTextSimple
              placeholder={`+36303534672`}
              variant="light"
              id={"Telefonszáma"}
              name={"Telefonszáma"}
              value={telefonszam}
              disabled={isDisabled}
              error={telefonszamError}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Apply regex pattern to allow only numbers and one plus sign at the beginning
                // Apply regex pattern to allow only numbers
                const newValue = inputValue.replace(/\D/g, "");
                if (newValue?.length > 0) {
                  setTelefonszam(`+${newValue}`);
                } else {
                  setTelefonszam(`${newValue}`);
                }
              }}
            />
          </div>
          <div className="flex flex-col gap-[0.625rem] mt-[1.6rem]">
            <label className="text-[1rem] font-lato font-normal leading-normal">
              Email cím<span className="text-red-500">*</span>
            </label>
            <InputTextSimple
              placeholder={`kovacs.bela@gmail.com`}
              variant="light"
              id={"email"}
              name={"email"}
              value={email}
              disabled={isDisabled}
              error={emailError}
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
          </div>
          <div className="flex flex-col gap-[0.625rem] mt-[1.6rem]">
            <label className="text-[1rem] font-lato font-normal leading-normal">
              cím<span className="text-red-500">*</span>
            </label>
            <TextArea
              id="cim"
              name="cim"
              value={cim}
              disabled={isDisabled}
              error={cimError}
              onChange={(e) => setCim(e.target.value)}
              placeholder={`1234 Budapest, Király utca 7. `}
              variant="light"
            />
          </div>
          <div className="mt-12 text-center">
            <Button spinnerVisible={true} label={`Hozzáadás`} px={`5`} onClick={saveCustomer} disabled={isDisabled} />
          </div>
        </Spinner>
      </ModalCenter>
    </>
  );
};

export default CreateCustomerModal;
